import { useState, createContext } from "react";

export const BasicListContext = createContext({});

/**
 * The context provider for the Ticket List.
 * Example of us for Material UI React Table.
 *
 * @param {Object} children The children components.
 * @returns
 */
function BasicListContextProvider({ children }) {
  /** -------------------------------- */
  // STATES NEEDED FOR MUI REACT TABLE //
  /** -------------------------------- */
  const [refresh, setRefresh] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [data, setData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  // Extra Query Params to get data to list
  const [extraQueryParams, setExtraQueryParams] = useState({
    active: 1,
  });
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });

  /** -------------------------------- */
  //  STATES CUSTOM FOR LISt FILTERS //
  /** -------------------------------- */

  const value = {
    isLoaded,
    setIsLoaded,
    data,
    setData,
    rowCount,
    setRowCount,
    columnFilters,
    setColumnFilters,
    pagination,
    setPagination,
    globalFilter,
    setGlobalFilter,
    sorting,
    setSorting,
    isLoading,
    setIsLoading,
    isError,
    setIsError,
    isRefetching,
    setIsRefetching,
    refresh,
    setRefresh,
    extraQueryParams,
    setExtraQueryParams,
  };

  return (
    <BasicListContext.Provider value={value}>
      {children}
    </BasicListContext.Provider>
  );
}

export default BasicListContextProvider;
